import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from 'reactstrap';
import Navigation from '../../components/Navigation/Navigation';
import IncomeExpenseFields from '../../components/Fields/IncomeExpenseFields';
import { IncomeExpensesValidator } from '../../utils/Validators';
import withBackgroundImage from '../../HOC/withBackgroundImage';
import debounce from 'debounce';

import { updateIncomeExpenses } from '../../actions/incomeExpensesAction';

import TagManager from 'react-gtm-module'

const tagManagerArgs = {
  dataLayer: {
      pageCategory: 'Income & expense',
      event: 'Credit Card Step 4'
  }
}

class IncomeExpenses extends Component {
  constructor(props) {
    super(props);

    this.validator = IncomeExpensesValidator();

    this.state = {
      income: this.props.income === undefined ? "" : this.props.income,
      rent: this.props.rent === undefined ? "" : this.props.rent,
      loans: this.props.loans === undefined ? "" : this.props.loans,
      creditcards: this.props.creditcards === undefined ? "" : this.props.creditcards,
      householdincome: this.props.householdincome === undefined ? "" : this.props.householdincome,
      investmentincome: this.props.investmentincome === undefined ? "" : this.props.investmentincome,
      validation: this.validator.valid()
    }

    this.onClickForward = this.onClickForward.bind(this);
    this.onClickBackward = this.onClickBackward.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.validateField = this.validateField.bind(this);
  } 

  componentDidMount() {
    TagManager.dataLayer(tagManagerArgs)
  }

  onClickForward(event) {
    event.preventDefault();

    this.setState({ validation: this.validator.validate(this.state) }, () => {
      
      if (this.state.validation.isValid) {
        var cardType = this.props.card.cpc;
        var monthlyIncome = Number.parseFloat(this.props.income);
        var yearlyIncome = monthlyIncome * 12;
        var minPersonalIncome = 0;

        switch (cardType) {
          case 'VIR':
            minPersonalIncome = 60000;

            if (yearlyIncome < minPersonalIncome) {
              this.props.history.replace('/IncomeExpenses/Finances');
            } else {
              this.props.history.replace('/AuthorizedUsers');
            }
            break;     
          case 'VPR':
            minPersonalIncome = 150000;

            if (yearlyIncome < minPersonalIncome) {
              this.props.history.replace('/IncomeExpenses/Finances');
            } else {
              this.props.history.replace('/AuthorizedUsers');
            }
            break;
          
          default:
            this.props.history.replace('/AuthorizedUsers');
            break;
        }
      }
    });
  }
  onClickBackward() {
    this.props.history.replace('/Occupation');
  }
  handleChange(event) {
    this.setState({
      validation: {...this.state.validation, [event.target.name]: this.validator.resetFieldValidation(event.target.name)},
      [event.target.name]: event.target.value
    }, () => {
      this.updateIncomeExpenses();
    });
  }
  validateField(event) {
    this.setState({
      validation: {...this.state.validation, [event.target.name]: this.validator.validateField(event.target.name, event.target.value)}
    });
  }
  updateIncomeExpenses = debounce(() => {    
    this.setState({
      householdincome: "",
      investmentincome: ""
    });

    this.props.updateIncomeExpenses({ income: this.state.income, rent: this.state.rent, loans: this.state.loans, creditcards: this.state.creditcards, householdincome: this.state.householdincome, investmentincome: this.state.investmentincome});
  }, 1000);
  render() {
    let fragment;

    if (this.props.card.cpc === "VIR") {
      fragment = <p>Qualifying personal annual income (before taxes) is $60,000 or $5,000 per month.</p>
    } else if (this.props.card.cpc === "VPR") {
      fragment = <p>Qualifying personal annual income (before taxes) is $150,000 or $12,500 per month.</p>
    }

    return (
      <div>
        <h1>Tell us about your income and expenses</h1>
        {fragment}
        <Form onSubmit={this.onClickForward}>          
          <IncomeExpenseFields handleChange={this.handleChange} validateField={this.validateField} {...this.state} />
          <Navigation onClickForward={this.onClickForward} onClickBackward={this.onClickBackward} />
        </Form>
      </div>);
  }
}

const mapStateToProps = state => ({
  ...state.incomeExpenses,
  card: state.card
});

const mapDispatchToProps = dispatch => ({
  updateIncomeExpenses: (incomeExpenses) => dispatch(updateIncomeExpenses(incomeExpenses))
});


export default connect(mapStateToProps, mapDispatchToProps)(withBackgroundImage("income-expenses")(IncomeExpenses));


// WEBPACK FOOTER //
// ./src/containers/IncomeExpenses/IncomeExpenses.js